import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.934 10.989c.098-.12.11-.094-.054-.094h-4.167a1 1 0 0 1-.957-1.292l2.233-7.329c.003-.026-2.97 3.553-8.923 10.737-.098.12-.11.094.054.094l4.168.002a1 1 0 0 1 .956 1.291l-2.233 7.328c-.003.026 2.97-3.553 8.923-10.737zM6.12 14.105c-1.003 0-1.467-.955-.824-1.732l8.907-10.75c1.002-1.211 2.19-.527 1.743.943l-2.233 7.329h4.167c1.003 0 1.467.955.824 1.732l-8.907 10.75c-1.002 1.211-2.19.527-1.743-.943l2.233-7.327-4.167-.002z"
});

var SvgLightning = function SvgLightning(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgLightning;